import { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getUncoveredSalesChannelWarnings = {
  name: "getUncoveredSalesChannelWarnings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ warnings: z.array(uncoveredSalesChannelWarningSchema) }),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { uncoveredSalesChannelWarningSchema as adminUncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
